"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnemyTackleZones = exports.getAllAdjacentSquares = exports.isAdjacent = void 0;
const status_1 = require("./status");
const isAdjacent = (p1, p2) => {
    if (p1 === null ||
        p2 === null ||
        p1.x === null ||
        p1.y === null ||
        p2.x === null ||
        p2.y === null) {
        return false;
    }
    return ((p1.x !== p2.x || p1.y !== p2.y) &&
        Math.abs(p1.x - p2.x) <= 1 &&
        Math.abs(p1.y - p2.y) <= 1);
};
exports.isAdjacent = isAdjacent;
/**
 * Returns all 8 adjacent squares around a given position
 */
const getAllAdjacentSquares = (x, y) => {
    return [
        { x: x - 1, y: y - 1 },
        { x: x, y: y - 1 },
        { x: x + 1, y: y - 1 },
        { x: x - 1, y: y },
        { x: x + 1, y: y },
        { x: x - 1, y: y + 1 },
        { x: x, y: y + 1 },
        { x: x + 1, y: y + 1 },
    ];
};
exports.getAllAdjacentSquares = getAllAdjacentSquares;
const getEnemyTackleZones = (location, teamId, players) => {
    // player a un format : { id1: {player1}, id2:{player2} etc...}
    return Object.values(players).filter((player) => {
        const res = (0, status_1.hasStatusTacleZone)(player) &&
            player.teamId !== teamId &&
            (0, exports.isAdjacent)(player, location);
        return res;
    });
};
exports.getEnemyTackleZones = getEnemyTackleZones;
